// gloss
export const EMAIL_REGEX = /^(?!\.)(?!.*\.\.)(?!.*\.@)[^\s@]+@[^\s@]+\.[^\s@]*[^\s@.]$/;

export const isValidEmail = (value: unknown): value is string => typeof value === 'string' && EMAIL_REGEX.test(value);
